/**
 * Moment Language Codes (for the App)
 */
export enum MomentLanguageCode {
  /**
   * Portuguese (Portugal)
   */
  ptPT = 'pt',

  /**
   * Portuguese (Brazil)
   */
  ptBR = 'pt-br',

  /**
   * Spanish (es)
   */
  esES = 'es',

  /**
   * Galician (Spain)
   */
  glES = 'gl',

  /**
   * English (UK) => They don't seem to have an English (US)
   */
  enGB = 'en-gb',
}
